<panel *ngIf="!selected.invoice && (!loading || !invoices.empty)">
  <div header class="uppercase bold">{{'Đơn nhập hàng xưởng' | lang}} ({{configs.invoiceResolvableDays}} {{'ngày' | lang}})</div>
  <text-filter right [target]="invoices" [placeholder]="'Tìm kiếm'"></text-filter>

  <table responsive class="data hover" *ngIf="!selected.invoice">
    <tr>
      <th class="text-left nowrap"><sortable [target]="invoices" [extractor]="extractor('Stamp')">{{'Ngày' | lang}}</sortable></th>
      <th class="text-left"><sortable [target]="invoices" [extractor]="extractor('ID')">{{'Mã đơn' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="invoices" [extractor]="extractor('State')" [selected]="true">{{'Trạng thái' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('SKUCount')">{{'Mặt hàng' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('LengthActualQuantity')">{{'Số mét' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('WeightActualQuantity')">{{'Số cân' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of invoices.matches" class="pointer" (click)="open(i)">
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="spacy bold text-danger">{{i.Tag}}</td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2}">{{state(i) | lang}}</td>
      <td>{{i.SKUCount | number : '1.0-2' : 'en-US'}}</td>
      <td>{{i.LengthCount + i.WeightCount | number : '1.0-2' : 'en-US'}}<unit>{{'cây' | lang}}</unit></td>
      <td>{{i.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m></td>
      <td>{{i.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg></td>
      <td>{{i.Total | number : '1.0-2' : 'en-US'}}<span class="hlf-margin-left opacity-75">{{i.Icon}}</span></td>
    </tr>
    <tr class="footer" *ngIf="invoices.pages.length > 1">
      <td [colSpan]="7" class="text-center"><pagination [target]="invoices"></pagination></td>
    </tr>
  </table>

</panel>

<div class="editor" *ngIf="selected.invoice">

  <div class="scrollable-x" #scrollableX>

    <div class="flex row">
      <panel [header]="false">

        <div class="flex col">

          <div class="flex space-between items-center header">
            <div class="uppercase bold">{{('Đơn nhập hàng xưởng' | lang)}} <span class="text-danger pointer" (click)="editTag()">{{selected.invoice.Tag}}</span> (<span [ngClass]="{'text-primary pointer' : editable}" (click)="editStamp()">{{selected.invoice.Stamp | date : 'dd-MM-yyyy'}}</span>)</div>
            <small class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
          </div>

          <div class="flex row" [ngClass]="{'full-height': !selected.invoice || !confirmable}">

            <div class="scrollable" #scrollableLeft>


              <table responsive class="data" *ngIf="selected.invoice">
                <tr>
                  <th class="text-top text-left">{{'Mã đặt hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Khách hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Mã hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Màu' | lang}}</th>
                  <th class="text-top text-center">{{'Số cây' | lang}}</th>
                  <th class="text-top text-left">{{'Dài / nặng từng cây' | lang}}</th>
                  <th class="text-top text-right">{{'Tổng dài' | lang}}</th>
                  <th class="text-top text-center">{{'Khấu trừ' | lang}}</th>
                  <th class="text-top text-right">{{'Tính tiền' | lang}}</th>
                  <th class="text-top text-right">{{'Giá nhập' | lang}}</th>
                  <th class="text-top text-right">{{'Thành tiền' | lang}}</th>
                </tr>

                <ng-container *ngFor="let order of this.selected.details; index as ox">
                  <tr *ngFor="let i of order; index as ix" [ngClass]="{'dark': ox % 2 == 0 && this.selected.details.length > 1}">
                    <td class="spacy nowrap bold" [ngClass]="{'text-primary': i.OrderID > 0, 'text-warning': i.OrderID < 0, 'text-danger': i.OrderID == 0}">{{ix < 1 ? i.OrderTag : ''}}</td>
                    <td class="nowrap uppercase">{{ix < 1 ? i.PartnerName : ''}}</td>
                    <td><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                    <td class="bold">{{i.Color}}</td>
                    <td class="text-info bold">{{i.records.length | number : '1.0-0' : 'en-US'}}</td>
                    <td>
                      <div class="flex inputs">
                        <span *ngFor="let o of i.records">{{o.ActualQuantity | number : '1.0-1' : 'en-US'}}<i *ngIf="editable" class="fa fa-times pointer text-danger hlf-margin-left" (click)="remove(o)"></i></span>
                      </div>
                    </td>
                    <td>
                      <b>{{statistics('ActualQuantity', [i]) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td><number-input class="bold text-info" [fit]="true" [allowNegative]="false" [value]="i.Reduced" (change)="setReduce(i, $event.target)"></number-input><product-unit [type]="i.Unit"></product-unit></td>
                    <td>
                      <b>{{statistics('QuoteQuantity', [i]) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td>
                      <b>{{i.QuotePrice | number : '1.1-1' : 'en-US'}}</b><synbol-per-unit [symbol]="CNY" [type]="i.Unit"></synbol-per-unit>
                    </td>
                    <td>
                      <b>{{statistics('Total', [i]) | number : '1.1-1' : 'en-US'}}</b><cny></cny>
                    </td>
                  </tr>

                  <tr class="small text-info" [ngClass]="{'dark' : ox % 2 == 0}" *ngIf="order.length > 1 && selected.details.length > 1">
                    <td class="nowrap bold uppercase">{{'Tổng thành phần' | lang}}</td>
                    <td></td>
                    <td *ngIf="hasGenericOrder"></td>
                    <td><b>{{statistics('SKU', order) | number : '1.0-0' : 'en-US'}}</b></td>
                    <td><b>{{statistics('Color', order) | number : '1.0-0' : 'en-US'}}</b></td>
                    <td><b>{{statistics('Count', order) | number : '1.0-0' : 'en-US'}}</b></td>
                    <td></td>
                    <td class="nowrap">
                      <b>{{statistics('ActualQuantity', order) | number : '1.1-1' : 'en-US'}}</b>
                      <m *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) < 1"></m>
                      <kg *ngIf="statistics('Count', order, 2) > 0 && statistics('Count', order, 1) < 1"></kg>
                      <unit *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) > 0">{{'đv' | lang}}</unit>
                    </td>
                    <td class="nowrap">
                      <b>{{statistics('ReducedQuantity', order) | number : '1.1-1' : 'en-US'}}</b>
                      <m *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) < 1"></m>
                      <kg *ngIf="statistics('Count', order, 2) > 0 && statistics('Count', order, 1) < 1"></kg>
                      <unit *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) > 0">{{'đv' | lang}}</unit>
                    </td>
                    <td class="nowrap">
                      <b>{{statistics('QuoteQuantity', order) | number : '1.1-1' : 'en-US'}}</b>
                      <m *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) < 1"></m>
                      <kg *ngIf="statistics('Count', order, 2) > 0 && statistics('Count', order, 1) < 1"></kg>
                      <unit *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) > 0">{{'đv' | lang}}</unit>
                    </td>
                    <td></td>
                    <td class="nowrap">
                      <b>{{statistics('Total', order) | number : '1.1-1' : 'en-US'}}</b><cny></cny>
                    </td>
                  </tr>

                </ng-container>

                <tr class="footer text-primary" *ngIf="!empty">
                  <td class="bold uppercase">{{'Tổng đơn' | lang}}</td>
                  <td></td>
                  <td *ngIf="hasGenericOrder"></td>
                  <td><b>{{sum('SKU', order) | number : '1.0-0' : 'en-US'}}</b></td>
                  <td><b>{{sum('Color', order) | number : '1.0-0' : 'en-US'}}</b></td>
                  <td><b>{{sum('Quantity', order) | number : '1.0-0' : 'en-US'}}</b></td>
                  <td></td>
                  <td class="nowrap">
                    <b>{{sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{sum('ReducedQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td></td>
                  <td class="nowrap"><b>{{sum('Total') | number : '1.1-1' : 'en-US'}}</b><cny></cny></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableLeft"></scrollbar>

          </div>

          <div class="flex" *ngIf="confirmable">
            <button class="bg-primary text-white" (click)="confirm()"><span>{{'Xác nhận nhập hàng' | lang}}</span></button>
          </div>
        </div>
      </panel>

      <panel [header]="false" *ngIf="selected.invoice && !details.empty">

        <div class="flex col">

          <text-filter [target]="details" [placeholder]="'Tìm theo độ dài'"></text-filter>
          <div class="flex row">
            <div class="scrollable" #scrollableRight>

              <table class="data hover">
                <tr *ngIf="details.pageIndex == 0 && !details.empty">
                  <td [colSpan]="5"><button class="w-100 pointer text-white bg-warning" (click)="addAll()"><span>{{'Thêm toàn bộ' | lang}}</span></button></td>
                </tr>
                <tr>
                  <th class="text-left">Mã hàng</th>
                  <th class="text-center">Màu</th>
                  <th class="text-center">Dài / nặng</th>
                  <th class="text-right">Khách</th>
                  <th class="text-right"></th>
                </tr>
                <tr *ngFor="let i of details.pageMatches" class="pointer" (click)="add(i)">
                  <td class="text-left"><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                  <td class="text-center bold text-info">{{i.Color}}</td>
                  <td class="text-right">{{i.ActualQuantity}}<product-unit [type]="i.Unit"></product-unit></td>
                  <td class="text-right nowrap">{{partner(i)}}</td>
                  <td><i class="fa fa-times text-danger pointer bold" (click)="cancel(i)"></i></td>
                </tr>
                <tr class="footer" *ngIf="details.pages.length > 1">
                  <td [colSpan]="5" class="text-center"><pagination [target]="details"></pagination></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableRight"></scrollbar>
          </div>
        </div>
      </panel>

    </div>

  </div>

  <scrollbar [target]="scrollableX" class="bottom"></scrollbar>
</div>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
